<template>
  <span class="unUsedBadge">
    {{ $t('labels.unUsed') }}
  </span>
</template>

<script>
export default {
  name: 'UnUsedBadge'
}
</script>

<style lang="scss" scoped>
.unUsedBadge {
  background: #E9446A;
  border-radius: 12px;
  font-weight: bold;
  color: #FFF;
  font-size: 12px;
  padding: 4px 6px;
}
</style>